@import '../../../assets/styles/variables';
@import '../../../assets/styles/typography';
@import '../../../../node_modules/@cpt/pci/postnl-styles/settings';
@import '../../../../node_modules/@cpt/pci/postnl-styles/tools/utilities';
@import '../../../../node_modules/@cpt/pci/postnl-styles/components/flyout';

:host(*) {
    all: initial;
    font-family: $font-family-bodytext;
    font-size: 16px;
}

.pnl-text-input {
    display: flex;
    position: relative;
    flex-direction: column;
    margin-bottom: 1rem;
    font-family: $font-family-bodytext, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-feature-settings: 'ss03' on, 'ss01' on;
    text-align: left;

    @media (min-width: 48em) {
        flex-direction: row;
        flex-wrap: wrap;
        align-items: center;
    }
}

.pnl-text-input__label {
    margin-bottom: 0.5rem;

    @media (min-width: 48em) {
        flex: 0 0 30%;
        margin-bottom: 0;
        padding-right: 1rem;
        text-align: right;
    }
}

.pnl-text-input__text {
    height: 40px;
    padding: 0.375em 0.5em;
    border: 1px solid $color-border-strong;
    border-radius: 4px;
    color: $color-body-text-default;
    font-family: $font-family-bodytext, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-feature-settings: 'ss03' on, 'ss01' on;
    font-size: 1em;
    font-weight: 300;

    @media (min-width: 48em) {
        flex: 1;
        max-width: 24em;
    }

    &:focus:not(:focus-visible) {
        outline: 0;
    }

    &:focus-visible {
        outline-offset: 2px;
        outline-color: $color-border-focus-outline;
        outline-width: 2px;
        outline-style: solid;
    }
}

.pnl-text-input__error {
    padding-left: 0.5em;
    color: $error-text;
    font-size: 0.875em;
    font-weight: normal;

    @media (min-width: 48em) {
        flex: 0 0 70%;
        margin-left: 30%;
    }
}

// The search-form uses the flyout component for the results, though
// some modifications are made.
.pci-flyout {
    &.pnl-search-form {
        display: block;
        position: relative;
        box-sizing: border-box;
        white-space: nowrap;

        @media (min-width: $bp-nav) {
            margin: 1.25em 0; //prevents header collapsing when search is focused
        }
    }
}

.pnl-search-form__form {
    text-align: right;
}

.pnl-text-input__text {
    &.pnl-search-form__input {
        width: 100%;
        max-width: 100%;
        font-size: 1em;

        @media (min-width: $bp-nav) {
            width: 4em;
            padding-right: 3em;
            transition: width 500ms cubic-bezier(0.4, 0, 0.2, 1);
            transform-origin: right;

            &::placeholder {
                opacity: 0;
            }

            .pnl-search-form:focus-within & {
                width: 22.5em;

                &::placeholder {
                    opacity: 1;
                }
            }
        }

        &:focus-visible ~ .pnl-search-form__button {
            background-color: $color-background-button-primary-default;
            border-radius: 4px;
            color: $color-white;
        }
    }
}

.pnl-search-form__button {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: auto;
    padding: 0 0.5em;
    border: none;
    font-size: 1.5rem;
    color: $color-icon-default;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    background-color: transparent;

    &:hover,
    &:focus:not(:focus-visible) {
        outline: 0;
    }

    &:hover {
        cursor: pointer;
    }
}

[disabled] {
    //prevents the button from focusing the form when disabled
    pointer-events: none;
}

.pnl-search-form__icon {
    display: flex;

    > svg {
        width: 0.75em;
        pointer-events: none;
    }
}

.pci-flyout__list {
    &.pnl-search-form__suggestions-list {
        top: 100%;
        left: 0;
        right: 0;
        transform: translateX(0);
        padding: 1em 1em 0;
        text-align: left;
        z-index: 9999;

        &::before {
            content: none;
        }
    }
}

.pnl-search-form__suggestions-list-item {
    white-space: pre-wrap;

    & + & {
        margin-top: 1em;
    }
}

.pnl-search-form__suggestions-list-item--direct {
    border-top: 1px solid $color-border-default;
    margin-right: -1em;
    margin-left: -1em;
    padding-right: 1em;
    padding-left: 1em;

    & + & {
        margin-top: 0;
    }
}

.pnl-search-form__suggestions-link {
    display: block;
    font-weight: 300;
    color: $color-body-text-default;
    text-decoration: none;

    &:hover,
    &:focus-visible {
        border-bottom-color: transparent;
        color: $color-text-button-secondary-default;
    }

    &:focus:not(:focus-visible) {
        outline: none;
    }

    .pnl-search-form__suggestions-list-item--direct & {
        display: flex;
        align-items: center;
        margin-left: -1em;
        margin-right: -1em;
        padding: 1em;

        &:focus:not(:focus-visible) {
            outline: none;
        }

        &:hover,
        &:focus-visible {
            color: inherit;
            background-color: lighten($color-border-focus-outline, 50%);
        }
    }
}

.pnl-search-form__suggestions-image {
    flex-basis: 20%;
    margin-right: 1em;

    > img {
        max-width: 100%;
        height: auto;
    }
}

.pnl-search-form__suggestions-title {
    margin-top: 0;
    margin-bottom: 0;
    font-size: 1.125em;
    font-weight: normal;
    color: $color-text-button-secondary-default;
}

.pnl-search-form__suggestions-text {
    margin-top: 0;
    margin-bottom: 0;
}
